<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-10-12 20:31:38
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-07 10:14:03
-->
<template>
	<div>
		<!-- 选择达人的时候，如果没选择达人联系人，则展示它（需要同时满足2种条件） -->
		<span class="font-h5-regular yx-color-text-placeholder" v-if="locked">请先选择达人联系人</span>
		<template v-else>
			<div v-if="loading" class="font-h5-regular yx-color-text-primary">获取地址中....</div>
			<div v-else class="flex-just-between flex-align-start flex-row">
				<template v-if="address || deliveryAddr">
					<span class="font-h5-regular yx-color-text-primary line-ellipsis-2">
						<span>
							{{ address }}
							{{ deliveryAddr }}
						</span>
					</span>
					<el-button type="text" @click="showAddressDraw('edit')" style="height: 23px; line-height: 23px">{{
						this.isTz ? '修改' : '编辑'
					}}</el-button>
				</template>
				<el-button v-else type="text" @click="showAddressDraw()" style="height: 23px; line-height: 23px">新增地址</el-button>
			</div>
		</template>
		<!-- 新增地址 -->
		<AddAdressDraw ref="addAdressDraw" @refreshList="getAddress($event)"></AddAdressDraw>

		<!-- 团长地址列表 -->
		<AddressManageDrawer ref="addressManageDrawer" @setAddress="setAddress"></AddressManageDrawer>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin';
import { anchorDefaultSite } from '@/api/cooperationProgress';
import { getInstitutionAnchorSite } from '@/api/secondColonelManage';
import AddressManageDrawer from '@/components/business/addressManageDrawer';
export default {
	name: 'deliveryAddressCell',
	mixins: [mixin],
	data() {
		return {
			province: '',
			city: '',
			area: '',
			deliveryAddr: '',
			addAdress: false,
			loading: true,
			tzMessage: {},
			delForm: {},
			delivery_id: '',
		};
	},
	mounted() {
		//团长的话直接调用接口
		if (this.row.team_institution_id) return this.getAddress();
	},
	watch: {
		'row.team_institution_id': {
			handler() {
				if (this.row.isGetAddress) {
					this.getAddress();
				}
			},
			deep: true,
			immediate: true,
		},
		rowId() {
			if (this.row.form.province) {
				this.addAdress = false;
				this.row.isChecked = true;
				const { province = '', city = '', area = '', delivery_addr } = this.row.form;
				this.province = province;
				this.city = city;
				this.area = area;
				this.deliveryAddr = delivery_addr;
			}
		},
	},
	components: {
		AddAdressDraw: () => import('@/components/business/addAdressDraw'),
		AddressManageDrawer,
	},
	computed: {
		address() {
			return `${this.province}${this.province ? '/' : ''}${this.city}${this.city ? '/' : ''}${this.area}${this.area ? '/' : ''}`;
		},
		isDr() {
			return this.row.isDr;
		},
		isTz() {
			return this.row.isTz;
		},
		//当前row如果不存在team_institution_id那么就会锁上
		locked() {
			return !this.row.team_institution_id && this.isDr;
		},
		tzId() {
			return this.row.team_institution_id || '';
		},
		drId() {
			return this.row.anchor_id || '';
		},
		rowId() {
			return this.row.id;
		},
	},
	methods: {
		//获取收货地址
		async getAddress() {
			this.row.isChecked = false;
			this.loading = true;
			let params = {
				team_institution_id: this.tzId || 0,
				anchor_id: this.drId,
			};
			const { data } = this.isDr ? await anchorDefaultSite({ contact_id: this.tzId }) : await getInstitutionAnchorSite(params);
			this.row.form = data || {};
			this.province = data?.province || '';
			this.city = data?.city || '';
			this.area = data?.area || '';
			this.deliveryAddr = data?.delivery_addr;
			this.loading = false;
			this.delivery_id = data.delivery_id;
			// code存在的话，就是编辑，不存在为新增
			if (!data.code) return (this.addAdress = true); //走新增路线，此时，isChecked仍为false
			this.addAdress = false;
			this.row.isChecked = true;
		},
		// 地址管理抽烟使用地址 更改地址
		setAddress(addInfo) {
			this.row.form = addInfo;
			this.province = addInfo.province;
			this.city = addInfo.city;
			this.area = addInfo.area;
			this.deliveryAddr = addInfo.delivery_addr;
			this.delivery_id = addInfo.delivery_id;
		},
		//新增/编辑收货地址
		showAddressDraw(v) {
			const { anchor_id = '', team_institution_id } = this.row;
			if (v == 'edit' && this.isTz) {
				return this.$refs.addressManageDrawer.show(team_institution_id, this.delivery_id);
			}
			let role = this.isDr ? 'isDr' : 'isTz';
			this.$refs.addAdressDraw.show({
				tzId: team_institution_id,
				drId: anchor_id,
				role,
				v,
				delivery_id: this.delivery_id,
			});
		},
	},
};
</script>
